const headToHeadAnalysis = (v, i, l) => {
  const hg = v.goal_home ?? Object.values(v.goals ?? {}).filter((v2, i2, l2) => v2.team == "home").length;
  const ag = v.goal_away ?? Object.values(v.goals ?? {}).filter((v2, i2, l2) => v2.team == "away").length;
  delete v.events;
  delete v.fouls;
  delete v.injurys;
  delete v.offsides;
  delete v.yellowcards;
  delete v.home_lineup;
  delete v.away_lineup;
  delete v.home_substitutes;
  delete v.away_substitutes;
  return {
    ...v,
    hg,
    ag,
    winner: hg > ag ? "H" : hg == ag ? "D" : "A"
    // home:Object.values(v.goals).filter((v,i,l)=>v.team==),
    // scored: sc,
    // conceeded: cc,
    // result: sc > cc ? "W" : sc == cc ? "D" : "L",
    // matchid: v.id,
    // start: v.start,
  };
};
export {
  headToHeadAnalysis as h
};
